import React from 'react';

export default function LinkSVG() {
    return (
        <svg height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.2507 12.7766C16.1036 13.0558 16.9063 13.5104 17.627 14.1522C20.2502 16.4877 20.6008 20.4004 18.3854 22.8887L14.819 26.8943C12.6017 29.3609 8.68662 29.4758 6.06341 27.1401C3.4284 24.7942 3.08965 20.892 5.30503 18.4038L8.87146 14.398" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10"/>
            <path d="M16.8816 19.0104C16.0287 18.7311 15.2261 18.2765 14.5053 17.6347C11.8821 15.2992 11.5315 11.3866 13.7469 8.89833L17.3133 4.89257C19.5187 2.41547 23.4438 2.28952 26.0789 4.63558C28.7021 6.97109 29.0526 10.8837 26.8373 13.372L23.2708 17.3777" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10"/>
        </svg>
    )
}